<div class="modal-overlay">
  <div class="modal-container">
    <div class="modal-header">
      <h2 class="modal-title">{{ 'COUNTRY_SELECTOR.TITLE' | translate }}</h2>
      <p class="modal-subtitle">{{ 'COUNTRY_SELECTOR.SUBTITLE' | translate }}</p>
    </div>

    <div class="modal-body">
      <div class="country-search">
        <input
          type="text"
          [(ngModel)]="searchTerm"
          [placeholder]="'COUNTRY_SELECTOR.SEARCH_BY_NAME' | translate"
          class="country-search-input"
        />
      </div>
      @if (countries()) {
        <div class="countries-list">
          @for (country of filteredCountries(); track country.uuid) {
            <div
              class="country-item"
              [class.selected]="isSelected(country)"
              (click)="selectCountry(country)"
            >
              <div class="country-info">
                <img
                  [src]="getCountryFlag(country.name)"
                  [alt]="country.name + ' flag'"
                  class="country-flag"
                />
                <span class="country-name">{{ country.name }}</span>
              </div>
              @if (isSelected(country)) {
                <img src="assets/img/icons/vector/checked.svg" alt="Selected" class="check-icon" />
              }
            </div>
          }
        </div>
      } @else {
        <div class="loading-state">
          <app-loader size="sm" message="COUNTRY_SELECTOR.LOADING" />
        </div>
      }
    </div>

    <div class="modal-footer">
      <button class="confirm-btn" [disabled]="!selectedCountry" (click)="confirmSelection()">
        {{ 'COUNTRY_SELECTOR.CONFIRM' | translate }}
      </button>
    </div>
  </div>
</div>
